import type { Mutation, QueryClient, QueryKey } from '@tanstack/react-query';

import { isSameEndpointQuery } from '@common/api/isSameEndpointQuery';

export const createMutationOnSuccessOptions = async (
  queryClient: QueryClient,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
) => {
  if (mutation.meta) {
    const { reset, invalidates } = mutation.meta as {
      reset?: Array<QueryKey>;
      invalidates?: Array<QueryKey>;
    };

    if (reset) {
      queryClient.resetQueries({
        predicate: (query) => {
          const hasIncludeQueryKey = reset.some((queryKeys) => {
            if (isSameEndpointQuery(query, queryKeys)) return true;

            const hasAllQueryKey = queryKeys.every((queryKey) =>
              query.queryKey.includes(queryKey),
            );

            return hasAllQueryKey;
          });

          return hasIncludeQueryKey;
        },
      });
    }
    if (invalidates) {
      await queryClient.invalidateQueries({
        predicate: (query) => {
          const hasIncludeQueryKey = invalidates.some((queryKeys) => {
            if (isSameEndpointQuery(query, queryKeys)) return true;

            const hasAllQueryKey = queryKeys.every((queryKey) =>
              query.queryKey.includes(queryKey),
            );

            return hasAllQueryKey;
          });

          return hasIncludeQueryKey;
        },
      });
    }
  }
};
